var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchieve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M424 472V456H256C145.54 456 56 366.46 56 256C56 145.54 145.54 56 256 56C366.46 56 456 145.54 456 256C456.061 292.69 445.976 328.683 426.86 360H366.85C390.769 334.506 405.169 301.546 407.624 266.674C410.078 231.802 400.438 197.15 380.327 168.556C360.216 139.962 330.863 119.174 297.215 109.695C263.567 100.216 227.679 102.624 195.6 116.515C163.52 130.407 137.209 154.931 121.099 185.956C104.99 216.981 100.067 252.611 107.161 286.842C114.254 321.073 132.929 351.812 160.041 373.882C187.152 395.951 221.042 408 256 408H424V392L488 432L424 472Z",
    fill: "#FFD33A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.33 232C330.781 227.057 328.751 222.277 326.27 217.73L344 200L312 168L294.27 185.73C289.723 183.249 284.943 181.219 280 179.67V152H232V179.67C227.057 181.219 222.277 183.249 217.73 185.73L200 168L168 200L185.73 217.73C183.249 222.277 181.219 227.057 179.67 232H152V280H179.67C181.219 284.943 183.249 289.723 185.73 294.27L168 312L200 344L217.73 326.27C222.277 328.751 227.057 330.781 232 332.33V360H280V332.33C284.943 330.781 289.723 328.751 294.27 326.27L312 344L344 312L326.27 294.27C328.751 289.723 330.781 284.943 332.33 280H360V232H332.33Z",
    fill: "#2978B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 312C286.928 312 312 286.928 312 256C312 225.072 286.928 200 256 200C225.072 200 200 225.072 200 256C200 286.928 225.072 312 256 312Z",
    fill: "#E9EEF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 280C269.255 280 280 269.255 280 256C280 242.745 269.255 232 256 232C242.745 232 232 242.745 232 256C232 269.255 242.745 280 256 280Z",
    fill: "#2978B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 56V40L192 80L233.129 105.706L256 120V104C296.313 104 334.975 120.014 363.48 148.52C391.986 177.025 408 215.687 408 256C408 296.313 391.986 334.975 363.48 363.48C334.975 391.986 296.313 408 256 408H24V456H256C258.68 456 261.347 455.947 264 455.84C370.75 451.64 456 363.78 456 256C456 145.54 366.46 56 256 56Z",
    fill: "#3397E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168 432L104 392V408H24V456H104V472L168 432Z",
    fill: "#EB423F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieve);
export default __webpack_public_path__ + "static/media/Achieve.c3b4a0d9227babf71e83bc63d0b89cae.svg";
export { ForwardRef as ReactComponent };